import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';


export interface EmployeeList {
  item: string;
  code : string;
  store : string;
  banchno : string;
  category : string;
  quantity : number;
  unit : number;
  currrate : number;
  listing : string;
  refresh : any;
 }
 
 const ELEMENT_DATA: EmployeeList[] = [
   {item: 'samsung2', code: 'samsung2',store : 'FG 09',banchno : '',
   category :'100 GM natural',quantity:40,listing : 'product',unit : 55,currrate :20000,refresh: ''},
   {item: 'samsung5', code:'samsung5',store : 'FG 05',banchno : '',
   category :'300 GM natural',quantity:0,listing : 'product',unit : 555,currrate :30000,refresh: ''},
   {item: 'samsung s20', code:'samsung s20',store : 'FG 09',banchno : '',
   category :'10 GM natural',quantity:2,listing : 'item',unit : 5,currrate :30000,refresh: ''},
   {item: 'samsung s20', code:'samsung s20',store : 'FG 07',banchno : '',
   category :'50 GM natural',quantity:2,listing : 'product',unit : 56,currrate :22000,refresh: ''},
   {item: 'samsung s22', code: 'samsung s22',store : 'FG 04',banchno : '',
   category : '100 GM natural',quantity:53,listing : 'item',unit : 9,currrate :22050,refresh: ''},
   {item: 'samsung s202', code: 'samsung s202',store :'FG 08',banchno : '',
   category :'1000 GM natural',quantity:4,listing : 'product',unit : 4,currrate :2205,refresh: ''},
   {item: 'samsung m20', code: 'samsung m20',store : 'FG 09',banchno : '',
   category :'700 GM natural',quantity:7,listing : 'item',unit : 65,currrate :22876,refresh: ''},
   {item:'samsung s20', code: 'samsung s20',store : 'FG 02',banchno : '',
   category :'60 GM natural',quantity:6,listing :'product',unit : 78,currrate :22876,refresh: ''},
   {item:'samsung s20', code: 'samsung s20',store : 'FG 03',banchno : '',
   category :'100 GM natural',quantity:8,listing : 'item',unit : 9,currrate :22876,refresh: ''},
   {item:'samsung s20', code: 'samsung s20',store : 'FG 01',banchno : '',
   category :'100 GM natural',quantity:7,listing : 'product',unit : 2,currrate :22876,refresh: ''},
 ];


@Component({
  selector: 'app-stock-breakdown',
  templateUrl: './stock-breakdown.component.html',
  styleUrls: ['./stock-breakdown.component.scss']
})
export class StockBreakdownComponent implements OnInit {


  displayedColumns: string[] = ['item','code','store','banchno','category','quantity','listing','unit','currrate','edit','refresh'];
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);

  @ViewChild('pprtable', { static: false }) pprtable!: ElementRef;
  
  @ViewChild(MatSort)
  sort!: MatSort;

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.pprtable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
  
    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'itemPlanningReport.xlsx');
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }

}
